// extracted by mini-css-extract-plugin
module.exports = {"questionList":"Qcomponent_style_questionList__F_DFJ","title":"Qcomponent_style_title__3MkxH","arrow":"Qcomponent_style_arrow__eHGQx","content":"Qcomponent_style_content__3XdTF"};